
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1wzqe_1sx77_93",
  "search-field": "awsui_search-field_1wzqe_1sx77_104",
  "input-wrapper": "awsui_input-wrapper_1wzqe_1sx77_110",
  "add-token": "awsui_add-token_1wzqe_1sx77_114",
  "tokens": "awsui_tokens_1wzqe_1sx77_121",
  "token-operator": "awsui_token-operator_1wzqe_1sx77_125",
  "property-editor": "awsui_property-editor_1wzqe_1sx77_129",
  "token-editor": "awsui_token-editor_1wzqe_1sx77_130",
  "property-editor-form": "awsui_property-editor-form_1wzqe_1sx77_134",
  "token-editor-form": "awsui_token-editor-form_1wzqe_1sx77_135",
  "property-editor-field-property": "awsui_property-editor-field-property_1wzqe_1sx77_138",
  "token-editor-field-property": "awsui_token-editor-field-property_1wzqe_1sx77_139",
  "property-editor-field-operator": "awsui_property-editor-field-operator_1wzqe_1sx77_142",
  "token-editor-field-operator": "awsui_token-editor-field-operator_1wzqe_1sx77_143",
  "property-editor-field-value": "awsui_property-editor-field-value_1wzqe_1sx77_146",
  "token-editor-field-value": "awsui_token-editor-field-value_1wzqe_1sx77_147",
  "property-editor-cancel": "awsui_property-editor-cancel_1wzqe_1sx77_150",
  "token-editor-cancel": "awsui_token-editor-cancel_1wzqe_1sx77_151",
  "property-editor-submit": "awsui_property-editor-submit_1wzqe_1sx77_154",
  "token-editor-submit": "awsui_token-editor-submit_1wzqe_1sx77_155",
  "property-editor-actions": "awsui_property-editor-actions_1wzqe_1sx77_158",
  "token-editor-actions": "awsui_token-editor-actions_1wzqe_1sx77_159",
  "custom-content-wrapper": "awsui_custom-content-wrapper_1wzqe_1sx77_177",
  "custom-control": "awsui_custom-control_1wzqe_1sx77_181",
  "input": "awsui_input_1wzqe_1sx77_110",
  "results": "awsui_results_1wzqe_1sx77_189",
  "results-visible": "awsui_results-visible_1wzqe_1sx77_195",
  "separator": "awsui_separator_1wzqe_1sx77_199",
  "toggle-collapsed": "awsui_toggle-collapsed_1wzqe_1sx77_206",
  "token-trigger": "awsui_token-trigger_1wzqe_1sx77_211",
  "remove-all": "awsui_remove-all_1wzqe_1sx77_217",
  "token-label": "awsui_token-label_1wzqe_1sx77_218",
  "join-operation": "awsui_join-operation_1wzqe_1sx77_219"
};
  